var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',[_vm._v("Gallery Page")]),_vm._v(" "),_c('gallery',{attrs:{"images":_vm.images,"index":_vm.index},on:{"close":function($event){_vm.index = null}}}),_vm._v(" "),_vm._l((_vm.images),function(image,imageIndex){return _c('div',{key:imageIndex,staticClass:"image",on:{"click":function($event){_vm.index = imageIndex}}})})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3b32816e","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/programPages/Gallery.vue
// module id = 121
// module chunks = 1